var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 56,
    viewBox: "0 0 39 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.28223V35.2189L26.8817 8.28223H0Z",
    fill: "#00142C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1788 0V10.0733L36.8365 11.4164L5.03333 43.2405L0 38.2039L38.1788 0Z",
    fill: "#0EC9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1788 12.7227V22.7959L36.8365 24.139L11.3716 49.6207L6.33826 44.5468L38.1788 12.7227Z",
    fill: "#0EC9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 50.926L13.3477 51.5976L14.0188 52.2318L17.7472 56L38.1788 35.5922V25.4443L12.7139 50.926Z",
    fill: "#0EC9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5270b17b716f9f24400fc87abe46e5d2.svg";
export { ForwardRef as ReactComponent };